import { useEffect } from "react";
import { AlertCircle, CheckCircle2, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { useGoogleCallback } from "@/hooks/use-google-callback";

export function GoogleCallbackPage() {
  const { t } = useTranslation();
  const { state, result, error } = useGoogleCallback();

  useEffect(() => {
    if (state !== "success" || !result?.return_path) return;
    const timer = window.setTimeout(() => { window.location.href = result.return_path!; }, 1500);
    return () => window.clearTimeout(timer);
  }, [result, state]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4 text-foreground">
      <div className="w-full max-w-md space-y-6 text-center">
        {state === "loading" && (
          <div className="flex flex-col items-center space-y-3">
            <Loader2 className="h-8 w-8 animate-spin text-blue-500 dark:text-blue-400" />
            <div><h1 className="text-xl font-semibold text-foreground">{t("connections:googleCallback.completing")}</h1><p className="mt-2 text-sm text-muted-foreground">{t("connections:googleCallback.completingDescription")}</p></div>
          </div>
        )}
        {state === "success" && (
          <div className="flex flex-col items-center space-y-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-green-100 dark:bg-green-950/60"><CheckCircle2 className="h-7 w-7 text-green-600 dark:text-green-400" /></div>
            <div><h1 className="text-xl font-semibold text-foreground">{t("connections:googleCallback.connected")}</h1><p className="mt-2 text-sm text-muted-foreground">{t("connections:googleCallback.connectedDescription")}</p></div>
            <Button onClick={() => { window.location.href = result?.return_path || "/connections"; }}>{t("connections:actions.goToConnections")}</Button>
          </div>
        )}
        {state === "error" && (
          <div className="flex flex-col items-center space-y-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100 dark:bg-red-950/60"><AlertCircle className="h-7 w-7 text-red-600 dark:text-red-400" /></div>
            <div><h1 className="text-xl font-semibold text-foreground">{t("connections:googleCallback.failed")}</h1><p className="mt-2 text-sm text-muted-foreground">{error || t("connections:googleCallback.failedDescription")}</p></div>
            <div className="flex gap-2"><Button variant="outline" onClick={() => { window.location.href = "/"; }}>{t("connections:page.backToChat")}</Button><Button onClick={() => { window.location.href = "/connections"; }}>{t("connections:actions.tryAgain")}</Button></div>
          </div>
        )}
      </div>
    </div>
  );
}
